import { ctx } from '@/util/context'
import { jsx, type JsxElementProps } from '@amazon/vinyl-tsx'
import { isObservableValue, type MaybeObservableValue } from '@amazon/vinyl-observable'
import { loadIcon, type IconName } from './Icons'

const { errorHandler } = ctx('Icon')

export type IconProps = JsxElementProps<'span'> & {
    readonly icon: MaybeObservableValue<IconName>
}

export function Icon(props: IconProps) {
    const { className, icon, ...rest } = props

    let latestIcon: IconName | undefined
    const show = (el: HTMLElement, name: IconName) => {
        if (name === latestIcon) return
        latestIcon = name
        el.setAttribute('data-icon', name)
        loadIcon(name)
            .then((iconHtml) => {
                if (name === latestIcon) el.innerHTML = iconHtml
            })
            .catch(errorHandler)
    }

    // Follows `icon` only while mounted: a render-time subscription would pin the
    // element to a long-lived source (the player's state) after it is gone.
    const el = (
        <span
            {...rest}
            className={'iconContainer ' + (className ?? '')}
            {...(isObservableValue(icon)
                ? { onConnect: (span: HTMLElement) => icon.onData((name) => show(span, name)) }
                : null)}
        />
    ) as HTMLElement
    show(el, isObservableValue(icon) ? icon.value : icon)
    return el
}
